import { render, staticRenderFns } from "./PersonModal.vue?vue&type=template&id=e52429b2"
import script from "./PersonModal.vue?vue&type=script&lang=js"
export * from "./PersonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports